export default {
    'activity': 'نشاط',
    'select-activity': 'اختر نشاط',
    'visit': 'زيارة',
    'delete-it': 'حذفها',
    'double-visit': 'زيارة مزدوجة'
}